// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../../core/_base/crud';
// Models
import { Customer } from '../../../core/auth/_models/customer.model';
import { C } from '@angular/cdk/keycodes';

const API_CUSTOMERS_URL = '/api/customer';

@Injectable()
export class CustomersService {
  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {
  }

  // CREATE =>  POST: add a new customer to the server
  createCustomer(customer: Customer): Observable<Customer> {
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<Customer>(API_CUSTOMERS_URL, customer, {headers: httpHeaders, responseType: 'text' as 'json'});
  }

  // READ
  getAllCustomers(): Observable<Customer[]> {
    return this.http.get<Customer[]>(API_CUSTOMERS_URL);
  }

  getCustomerById(customerId: string): Observable<Customer> {
    return this.http.get<Customer>(API_CUSTOMERS_URL + `/${customerId}`);
  }

  // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
  // items => filtered/sorted result
  // Server should return filtered/sorted result
  findCustomers(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

    const url = API_CUSTOMERS_URL + '/find';
    return this.http.get<QueryResultsModel>(url, {
      headers: httpHeaders,responseType: 'text' as 'json',
      params: httpParams
    });
  }

  // UPDATE => PUT: update the customer on the server
  updateCustomer(customer: Customer): Observable<any> {
    const httpHeader = this.httpUtils.getHTTPHeaders();
    return this.http.put(API_CUSTOMERS_URL + `/${customer.uuid}`, customer, {headers: httpHeader, responseType: 'text' as 'json'});
  }

  // UPDATE Status
  updateStatusForCustomer(customers: Customer[], status: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = {
      customersForUpdate: customers,
      newStatus: status
    };
    const url = API_CUSTOMERS_URL + '/updateStatus';
    return this.http.put(url, body, {headers: httpHeaders, responseType: 'text' as 'json'});
  }

  // DELETE => delete the customer from the server
  deleteCustomer(customerId: string): Observable<Customer> {
    const url = `${API_CUSTOMERS_URL}/${customerId}`;
    return this.http.delete<Customer>(url);
  }

  deleteCustomers(ids: string[] = []): Observable<any> {
    const url = API_CUSTOMERS_URL + '/deleteCustomers';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = {customerIdsForDelete: ids};
    return this.http.put<QueryResultsModel>(url, body, {headers: httpHeaders, responseType: 'text' as 'json'});
  }

  
  uploadCustomerLogo(customerId: string, logoFile: File): Observable<string> {
    const formData: FormData = new FormData();
    formData.append('logo', logoFile, logoFile.name);

   
    const reader = new FileReader();

    return new Observable<string>((observer) => {
      reader.onload = (event: any) => {
        const base64String = event.target.result;
        const uploadUrl = `${API_CUSTOMERS_URL}/${customerId}/logo`;

       
        this.http.post<string>(uploadUrl, { base64Image: base64String }).subscribe(
          (response: string) => {
            observer.next(response);
            observer.complete();
          },
          (error: any) => {
            observer.error(error);
          }
        );
      };

      reader.readAsDataURL(logoFile);
    });
  }

  getCustomerLogo(customerUUID:string): Observable<string> {
    const apiUrl = `${API_CUSTOMERS_URL}/${customerUUID}/getLogo`;
    return this.http.get<string>(apiUrl);
  }
}
